import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";
import { SLS_URL } from "../../Config/slsConfig";
import {
  DTOResultSBLookup,
  DTOSBLookup,
} from "../../Services/Serverless/Lookup/SBL/SBL.interface";
import {
  DTOPermitsLookup,
  DTOResponsePermitsLookup,
} from "../../Services/Serverless/Lookup/Permits/Permits.interface";
import {
  DTOResultTaxLookup,
  DTOTaxLookup,
} from "../../Services/Serverless/Lookup/TaxHistory/TaxHistory.interface";
import {
  DTOResponseViolationsLookup,
  DTOViolationsLookup,
} from "../../Services/Serverless/Lookup/Violations/Violations.interface";

export const LookupApi = createApi({
  reducerPath: "lookupApi",
  baseQuery: axiosBaseQuery({ baseUrl: SLS_URL }),
  endpoints: (builder) => ({
    lookupSbl: builder.query<DTOResultSBLookup, DTOSBLookup>({
      query: (address) => ({
        url: "/lookup/sbl",
        data: address,
        method: "POST",
      }),
    }),
    lookupPermit: builder.query<DTOResponsePermitsLookup, DTOPermitsLookup>({
      query: (sbl) => ({
        url: "/lookup/permits",
        data: sbl,
        method: "POST",
      }),
    }),
    lookupTax: builder.query<DTOResultTaxLookup, DTOTaxLookup>({
      query: (sbl) => ({
        url: "/lookup/tax-history",
        data: sbl,
        method: "POST",
      }),
    }),
    lookupViolations: builder.query<
      DTOResponseViolationsLookup,
      DTOViolationsLookup
    >({
      query: (sbl) => ({
        url: "/lookup/violations",
        data: sbl,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLookupSblQuery,
  useLookupPermitQuery,
  useLookupTaxQuery,
  useLookupViolationsQuery,
} = LookupApi;
